import React from "react";
// import * as d3KitGridmap from 'd3kit-gridmap'
// var d3KitGridmap = require('d3kit-gridmap');
import d3KitGridmap from 'd3kit-gridmap'
import { colorFillScale, colorTextScale } from "../utils/scale";
import { throttle } from 'throttle-debounce'
import { 
  MAP_MAX_WIDTH, 
  MAP_MIN_WIDTH, 
  SCALE_KEY, 
  MID_BREAKPOINT,
  MAX_FONT_SIZE,
  MIN_FONT_SIZE,
  TOOLTIP_FORMAT
} from '../config'
import {pymSendHeight} from '../utils/handlePym'
import Tooltip from './GridMapTooltip'

const tooltipFormatter = (label) => {
  let newLabel = label
  TOOLTIP_FORMAT.forEach((formatItem) => {
    if (formatItem.label == label) {
      newLabel = formatItem.replace
    }
  })
  return newLabel
}



class GridMap extends React.Component {
  constructor(props) {
    super(props)

    /* We use throttle to minimize the number of times we check window size
    this is important for performance
    */
    this.throttledHandleWindowResize = throttle(300, this.resizeMap);
    this.state = {
      tooltipActive: false,
      tooltipData: null,
    }
  }

  componentDidMount() {
    this.chart = this.initMap();
    window.addEventListener("resize", this.throttledHandleWindowResize);
    pymSendHeight()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.throttledHandleWindowResize);
  }

  initMap() {
    const { width, tileWidth } = this.handleWidth();
    return new d3KitGridmap(this.refs.canvas, {
      col: d => d.x,
      row: d => d.y,
      fill: d => colorFillScale(d[SCALE_KEY]),
      textColor: d => colorTextScale(d[SCALE_KEY]),
      stroke: 'white',
      initialWidth: width,
      tileWidth: tileWidth,
      tileHeight: tileWidth,
      textSize: this.handleFontSize(),
      margin: { left: 5, right: 5 }
    })
      .data(this.props.data)
      .resizeToFitMap()
      .on('tileMouseover', (d,i) => {
        this.setState({
          tooltipActive: true,
          tooltipData: d
        })
      })
      .on('tileMouseout', (d,i) => {
        this.setState({
          tooltipActive: false,
          tooltipData: null
        })
      })  
    }

  resizeMap = () => {
    const { width, tileWidth } = this.handleWidth();
    this.chart
      .options({
        tileWidth,
        tileHeight: tileWidth,
        margin: { left: 5, right: 5 },
        textSize: this.handleFontSize()
      })
      .resizeToFitMap();
  };

  handleFontSize = () => {
    const winWidth = window.innerWidth;
    let fontSize;
    if (winWidth < MAP_MIN_WIDTH) {
      fontSize = MIN_FONT_SIZE;
    } else if ((winWidth > MAP_MIN_WIDTH) && (winWidth < MID_BREAKPOINT)) {
      const range = MID_BREAKPOINT - MAP_MIN_WIDTH
      const rangeUnit = (MAX_FONT_SIZE - MIN_FONT_SIZE) / range
      fontSize = MIN_FONT_SIZE + (rangeUnit * (winWidth - MAP_MIN_WIDTH))
    } else {
      fontSize = MAX_FONT_SIZE
    }
    return fontSize + "px"
    //return winWidth < MID_BREAKPOINT ? "12px" : "16px"
  }

  handleWidth = () => {
    const winWidth = window.innerWidth;
    let width;
    if (winWidth > MAP_MAX_WIDTH) {
      width = MAP_MAX_WIDTH;
    } else if (winWidth < MAP_MIN_WIDTH) {
      width = MAP_MIN_WIDTH;
    } else {
      width = winWidth;
    }
    width = width * 0.9;
    let tileWidth = width / 12;
    return { width, tileWidth };
  };


  render() {
    const {tooltipActive, tooltipData} = this.state
    return (
      <div className="map__container">
      <Tooltip active={tooltipActive} data={
        {
          label: tooltipData ? tooltipData.name : null,
          display: tooltipData ? tooltipFormatter(tooltipData.personal_policy) : null
        }
      } />
        <div ref="canvas" ></div>
      </div>
    );
  }
}

export default GridMap;
